'use es6';

import { useState } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EmailReportBody from './EmailReportBody';
import EmailReportCard from './EmailReportCard';
import { getViewReportError } from 'dashboard-components/disabled-message/actions/view-report';
import { selectViewReportProblem } from 'dashboard-lib/public/userInfo/permissions/reportActions';
import { selectCustomReportsCount } from 'dashboard-lib/public/reports';
import { selectCustomReportsLimit } from 'dashboard-lib/public/userInfo/limits';
import { getAttributionReportScopeReq } from 'dashboard-lib/public/userInfo/scopes';
import { CUSTOM_REPORT_COUNT, CUSTOM_REPORT_LIMIT, MARKETING_HUB_UPGRADE_REQUIRED } from 'dashboard-lib/private/action-problem-solution/params/all-params';
import useNormalizedReport from '../../lib/useNormalizedReport';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailReport = ({
  overriddenReport
}) => {
  const customReportCount = useSelector(selectCustomReportsCount);
  const customReportsLimit = useSelector(selectCustomReportsLimit);
  const viewReportProblem = useSelector(selectViewReportProblem(overriddenReport));
  const attributionScopeRequirement = getAttributionReportScopeReq(overriddenReport);
  const ViewReportError = getViewReportError({
    [CUSTOM_REPORT_COUNT]: customReportCount,
    [CUSTOM_REPORT_LIMIT]: customReportsLimit,
    [MARKETING_HUB_UPGRADE_REQUIRED]: attributionScopeRequirement
  }, viewReportProblem);
  const [normalizationError, setNormalizationError] = useState(false);
  const normalizedReport = useNormalizedReport({
    report: overriddenReport,
    onError: () => {
      setNormalizationError(true);
    }
  });
  if (normalizationError) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reports.errors.emailReportNormalizationError"
    });
  }
  if (ViewReportError) {
    return /*#__PURE__*/_jsx(ViewReportError, {});
  }
  if (!normalizedReport) {
    return null;
  }
  return /*#__PURE__*/_jsx(EmailReportCard, {
    overriddenReport: normalizedReport,
    children: /*#__PURE__*/_jsx(EmailReportBody, {
      overriddenReport: normalizedReport
    })
  });
};
export default EmailReport;